<template>
  <div class="page-container">
    <div class="query-title">合同计划量调整查询</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <!-- <template #button>
            <table-button tip="导出" name="export" @click="exportExcel" />
            <table-button v-if="$_has(['WLY002', 'WLYALL'])" tip="审核通过" name="export" @click="applyContract('APPROVE')" />
            <table-button v-if="$_has(['WLY002', 'WLYALL'])" tip="审核拒绝" name="export" @click="applyContract('REJECT')" />
          </template> -->
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
            :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #action="{row}">
              <div style="display: flex;">
                <el-button type="text" size="mini" @click="downloadPdf(row)">下载</el-button>
                <el-upload
                  ref="upload"
                  action=""
                  :on-change="(file) => uploadFile(file, row)"
                  :show-file-list="false"
                  :auto-upload="false"
                >
                  <el-button slot="trigger" type="text" size="mini">上传</el-button>
                </el-upload>
              </div>
            </template>

            <template #file_id="{row}">
              <span v-if="!row.file_id">未上传文件</span>
              <el-button v-else type="text" size="mini" @click="downloadFile(row)">下载文件</el-button>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { printContractPlan, webUploadFile, apiAttachmentDownFile } from '@/api/common'
import { apiContractPlanList, apiContractPlanSave } from '@/api/sap/contract'
import { download } from '@/utils/frontExport'

import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/contractPlanNumQuery'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          // { type: 'checkbox', field: 'checkbox', title: '', width: 40 }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo'])
  },
  created() {
    this.initPage(pageConfig)
    this.gridOptions.columns.push(...[{
      field: 'file_id',
      title: '已上传文件',
      width: 100,
      slots: { default: 'file_id' }
    }, {
      field: 'action',
      title: '操作',
      width: 150,
      slots: { default: 'action' }
    }])
  },
  methods: {
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiContractPlanList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    formatMinus(data) {
      return data.map(item => {
        return {
          ...item,
          july_qty: item.july_qty - 0,
          july_adjqty: item.july_minus ? -1 * item.july_adjqty : item.july_adjqty - 0,
          august_qty: item.august_qty - 0,
          august_adjqty: item.august_minus ? -1 * item.august_adjqty : item.august_adjqty - 0,
          sep_qty: item.sep_qty - 0 ,
          sep_adjqty: item.sep_minus ? -1 * item.sep_adjqty : item.sep_adjqty - 0,
          oct_qty: item.oct_qty - 0,
          oct_adjqty: item.oct_minus ? -1 * item.oct_adjqty : item.oct_adjqty - 0,
          nov_qty: item.nov_qty - 0,
          nov_adjqty: item.nov_minus ? -1 * item.nov_adjqty : item.nov_adjqty - 0
        }
      })
    },
    async downloadFile({ file_id }) {
      const res = await apiAttachmentDownFile({ id: file_id })
      download(res.data)
    },
    async downloadPdf(row) {
      const { data } = await printContractPlan(this.formatMinus([row]))
      const a = document.createElement('a')
      const src = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
      a.href = src
      a.download = '2023年合同计划量调整申请表'
      document.body.appendChild(a)
      a.click()
      window.URL.revokeObjectURL(a.href)
      document.body.removeChild(a)
    },
    async uploadFile(file, row) {
      const formData = new FormData()
      formData.append('bizId', row.guid)
      formData.append('bizCode', 'planTransform')
      formData.append('formSecretLevel', 0)
      formData.append('name', file.name)
      formData.append('type', file.raw.type)
      formData.append('lastModifiedDate', file.raw.lastModifiedDate)
      formData.append('size', file.size)
      formData.append('file', file.raw)
      const { data } = await webUploadFile(formData)
      row.file_id = data.id
      const params = {
        mode: 'SAVE_FILE_ID',
        data: [row],
        user_bp: this.customerInfo.info.partner
      }
      const { msgtype, message } = await apiContractPlanSave(params)
      if (msgtype === 'E') {
        this.$message.error(message)
      } else {
        this.$message.success('上传成功！')
      }
    },
    // 导出全部 导出本页
    async exportExcel() {
      const params = {
        mv_bp: this.$store.getters.role.USER_BP,
        mv_role: this.$store.getters.role.ROLE,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, apiGetContractList)
      data.forEach(item => {
        item.channel = this.filterChannel(item.channel)
        item.chfl = this.filterChfl(item.chfl)
      })
      frontExport(this.gridOptions.columns, data, '合同信息')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/contract-manage/contractPlanNumQuery.vue